import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../../baseUrl";
import Spinner from "../../../Components/Spinner/Spinner";

const BatchUpdate = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  const [batchName, setBatchName] = useState("");

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const { id } = useParams();

  //   get exam by id
  useEffect(() => {
    axios
      .get(`${baseUrl}/admin/get-batch-details/${id}`, {
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
      })
      .then((res) => {
        setBatchName(res.data.batch.batchName);
      });
  }, [id, adminToken]);

  // handle submit for create exam
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        `${baseUrl}/admin/update-batch/${id}`,
        {
          batchName,
        },
        {
          headers: {
            Authorization: `Bearer ${adminToken}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          toast.success(res.data.message);
          navigate("/admin/students");
        } else {
          toast.error(res.data.message);
          navigate("/admin/students");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      {loading && <Spinner />}
      <form onSubmit={handleSubmit}>
        <div className="relative p-6 flex-auto">
          <label
            className="block mb-2 text-sm font-bold text-gray-700"
            htmlFor="examTitle"
          >
            Exam Title
          </label>
          <input
            className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-green-500 border-green-300 focus:shadow-outline"
            type="text"
            name="batchName"
            value={batchName}
            onChange={(e) => setBatchName(e.target.value)}
            required
          />
        </div>

        {/*body*/}
        {/*footer*/}
        <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
          <button
            className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            type="submit"
          >
            Save
          </button>
        </div>
      </form>
    </>
  );
};

export default BatchUpdate;
